import React, { useState } from 'react';
import {
  Badge,
  Button,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useOperatorMessages } from '../../contexts/OperatorMessageContext';
import {
  openCommunicationPopupWindow,
  type CommunicationPanelKey,
} from './cctvPopupRoutes';

const ITEMS: Array<{
  key: CommunicationPanelKey;
  label: string;
  icon: React.ReactNode;
}> = [
  { key: 'messages', label: '관제 메시지', icon: <MailOutlineIcon fontSize="small" /> },
  {
    key: 'facility-board',
    label: '시설 게시판',
    icon: <CampaignOutlinedIcon fontSize="small" />,
  },
  {
    key: 'control-archive',
    label: '관제 자료실',
    icon: <FolderSharedOutlinedIcon fontSize="small" />,
  },
];

/** 개별 관제 AppBar — 커뮤니케이션 드롭다운 (팝업) */
const CommunicationToolbarMenu: React.FC = () => {
  const { unreadCount } = useOperatorMessages();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handlePick = (key: CommunicationPanelKey) => {
    handleClose();
    openCommunicationPopupWindow(key);
  };

  return (
    <>
      <Button
        color="inherit"
        size="small"
        startIcon={
          <Badge badgeContent={unreadCount} color="error" max={99}>
            <ForumOutlinedIcon fontSize="small" />
          </Badge>
        }
        endIcon={<KeyboardArrowDownIcon fontSize="small" />}
        onClick={handleOpen}
        aria-haspopup="menu"
        aria-expanded={open ? 'true' : undefined}
        aria-label="communication-menu"
        sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
      >
        커뮤니케이션
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        {ITEMS.map((item) => (
          <MenuItem key={item.key} onClick={() => handlePick(item.key)} dense>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText>
              {item.key === 'messages' && unreadCount > 0
                ? `${item.label} (${unreadCount})`
                : item.label}
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default CommunicationToolbarMenu;
